'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FluentProvider", {
    enumerable: true,
    get: function() {
        return FluentProvider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _renderFluentProvider = require("./renderFluentProvider");
const _useFluentProvider = require("./useFluentProvider");
const _useFluentProviderStylesstyles = require("./useFluentProviderStyles.styles");
const _useFluentProviderContextValues = require("./useFluentProviderContextValues");
const FluentProvider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useFluentProvider.useFluentProvider_unstable)(props, ref);
    (0, _useFluentProviderStylesstyles.useFluentProviderStyles_unstable)(state);
    const contextValues = (0, _useFluentProviderContextValues.useFluentProviderContextValues_unstable)(state);
    return (0, _renderFluentProvider.renderFluentProvider_unstable)(state, contextValues);
});
FluentProvider.displayName = 'FluentProvider';
